import styled from 'styled-components';
import { colors } from '@keen.io/colors';
var Card = styled.div.withConfig({
  displayName: "Card",
  componentId: "keen-query-creator__sc-17rajgy-0"
})(["&&&{padding:10px 14px;background:", ";border:none;border-radius:0;box-sizing:border-box;box-shadow:0px 2px 4px 0px rgba(29,39,41,0.15);}"], colors.white['500']);
export default Card;